 const skills = [
  {
    id: 1,
    name: 'HTML CSS',
    percentage: 85,
    description:
      'I hold firm knowledge of HTML CSS. I am experienced in utilizing popular frameworks like BOOTSTRAP to create responsive and mobile-friendly designs.',
  },
  
    {
      id: 2,
      name: 'JavaScript',
      percentage: 60,
      description:
        'It allows me to add interactivity and dynamic features to websites. I can handle user interactions, perform client-side form validation',
    },
  
    {
      id: 3,
      name: 'Reactjs',
      percentage: 60,
      description:
        'I am skilled in React to create interactive web applications. I am skilled in utilizing other libraries and frameworks, such as React Router for efficient navigation',
    },
  
    {
      id: 4,
      name: 'Git and Github',
      percentage: 75,
      description:
        ' I effectively manage and track code changes and easy collaboration among team members.GitHub enables me to do organized development',
    },
  
    {
      id: 5,
      name: 'Backend development',
      percentage: 30,
      description:
        'I have learnt NODEJS and EXPRESS and also hold a proficient knowledage of MYSQL,Currently learning to apply these concepts in projects',
    },
  
    {
      id: 6,
      name: 'C/C++ DSA',
      percentage: 60,
      description: 'I possess a strong knowledge of C/C++ . I actively explore platforms like LeetCode and CodeChef (1422 rating) to sharpen my skills.',
    },
  ];

  export default skills;